import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

function WebSearchHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const loading = !result || !!result.isError;
  const input = toolUse.input as { query?: string } | undefined;
  const query = input?.query ?? "";
  return (
    <ToolStatus
      icon="search"
      text={loading ? "Searching…" : `Searched ${query}`}
      pending={loading && !interrupted}
    />
  );
}

function WebSearchBody({ toolUse, result }: ToolUseProps) {
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(toolUse.input, null, 2)}
      </pre>
      {result && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {JSON.stringify(result.output, null, 2)}
        </pre>
      )}
    </Text>
  );
}

export const webSearch: ChatTool = {
  name: "webSearch",
  Header: WebSearchHeader,
  Body: WebSearchBody,
};
